import Modal from "@components/Modal";
import BasicInfo from "@components/dashboard/details/BasicInfo";
import Agregator from "@components/dashboard/value/Agregator";
import UnitAccordion from "@components/dashboard/value/accordion/UnitAccordion";
import { useDashboardUIActions, useDashboardUIContext } from "@contexts/dashboardUI";

import { useProjectActions, useProjectContext } from "@contexts/projects";
import { isBuildingTrial } from "@utils/checkPermiossion";
import EscapeHandler from "@utils/escapeHandler";

const Value = () => {
  const { activeProject } = useProjectContext();
  const buildingTrial = isBuildingTrial();
  const { closeItemDetailOffcanvas } = useDashboardUIActions();

  if (!activeProject) return <></>;


  return (
    <>
      <BasicInfo />
      <EscapeHandler func={closeItemDetailOffcanvas} />
      {!buildingTrial && <Agregator />}
      <UnitAccordion />
    </>
  );
};

export default Value;